export const radiobutton = {
  root: {
    width: '1.2rem',
    height: '1.2rem',
  },
  icon: {
    checkedColor: '{primary.color}',
    checkedHoverColor: '{primary.color}',
  },
}
